module.exports = __webpack_public_path__ + "static/Underdown0-23d3eb4011e411c1fbffbb45dbe6b4e6.webp";